import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'react';
import { Modal as Modal$1 } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import getPortalContainer from '../../util/get-portal-container.js';
import Image from '../common/image.js';
import Button from '../common/button.js';
import RichMessage from '../common/rich-message.js';
import style from './modal.style.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CloseIcon = function CloseIcon(props) {
  return jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: jsx("path", {
      d: "M10.939 12 7.47 15.47a.749.749 0 1 0 1.06 1.06L12 13.061l3.47 3.469a.749.749 0 1 0 1.06-1.06L13.061 12l3.469-3.47a.749.749 0 1 0-1.06-1.06L12 10.939 8.53 7.47a.749.749 0 1 0-1.06 1.06L10.939 12Z"
    })
  }));
};

CloseIcon.defaultProps = {
  viewBox: "0 0 24 24"
};

var renderContent = function renderContent(pack, onAction) {
  if (!pack) return null;
  return jsxs(Fragment, {
    children: [jsx("div", {
      css: style.price,
      children: jsx("div", {
        css: style.salePriceText,
        children: jsx(RichMessage, {
          id: "InternetPackage.priceText",
          defaultMessage: "- THB/mo",
          xTags: ['price', 'price-unit', 'interval-type'],
          values: {
            price: pack.priceSpecial
          }
        })
      })
    }), jsx("div", {
      css: style.name,
      children: pack.name
    }), jsxs("div", {
      css: style.speed,
      children: [jsx("div", {
        css: style.speedLabel,
        children: jsx(FormattedMessage, {
          id: "download/upload",
          defaultMessage: "Download / Upload"
        })
      }), jsx("div", {
        css: style.speedText,
        children: jsx(RichMessage, {
          id: "InternetPackage.speedTextWithoutDLUnit",
          defaultMessage: "- / -",
          xTags: ['box', 'download', 'upload', 'upload-unit'],
          values: {
            download: pack.download,
            downloadUnit: pack.downloadUnit,
            upload: pack.upload,
            uploadUnit: pack.uploadUnit
          }
        })
      })]
    }), jsx("div", {
      css: style.bundle,
      children: (pack.image1 || pack.image2 || pack.image3 || pack.bundleContent) && jsxs(Fragment, {
        children: [jsx("div", {
          css: style.bundleLabel,
          children: pack.bundleText
        }), jsx("div", {
          css: style.bundleWrapper,
          children: jsxs("div", {
            css: style.bundleList,
            children: [pack.bundleContent && jsx("div", {
              className: "ck-content",
              dangerouslySetInnerHTML: {
                __html: pack.bundleContent
              }
            }), pack.image1 && jsx(Image, {
              css: style.bundleImage,
              mode: "contain",
              image: pack.image1
            }), pack.image1 && pack.image2 && jsx("div", {
              css: style.bundleDivider
            }), pack.image2 && jsx(Image, {
              css: style.bundleImage,
              mode: "contain",
              image: pack.image2
            }), pack.image1 && pack.image2 && pack.image3 && jsx("div", {
              css: style.bundleDivider
            }), pack.image3 && jsx(Image, {
              css: style.bundleImage,
              mode: "contain",
              image: pack.image3
            })]
          })
        })]
      })
    }), pack.benefitsList && jsxs("div", {
      css: style.benefit,
      children: [pack.benefitsList.length > 0 ? jsx("div", {
        css: style.benefitLabel,
        children: pack.bundleHeader.name
      }) : jsx(Fragment, {}), pack.benefitsList.length > 0 ? jsx("div", {
        css: style.benefitText,
        children: pack.benefitsList.map(function (benefit) {
          return jsx("div", {
            children: jsxs("div", {
              css: style.bundleListWrapper,
              children: [jsx(Image, {
                css: style.bullet,
                mode: "contain",
                image: benefit.bulletImage
              }), jsxs("div", {
                className: "flex-grow-1",
                children: [jsx("div", {
                  css: style.bulletTitle,
                  children: benefit.title
                }), jsx("div", {
                  className: "ck-content",
                  dangerouslySetInnerHTML: {
                    __html: benefit.description
                  }
                })]
              })]
            })
          }, benefit.id);
        })
      }) : jsx(Fragment, {})]
    }), jsx("div", {
      className: "d-flex align-items-center flex-column mt-2",
      children: pack.serviceBy.buttonOnModal && jsx(Button, {
        css: style.footerButton,
        link: pack.serviceBy.link,
        children: pack.serviceBy.buttonOnModal
      })
    })]
  });
};

var Modal = function Modal(_ref) {
  var pack = _ref.pack,
      show = _ref.show,
      onAction = _ref.onAction;
  var container = getPortalContainer();
  return jsxs(Modal$1, {
    css: style.modal,
    centered: true,
    show: show,
    container: container,
    children: [jsx("div", {
      css: style.close,
      onClick: function onClick() {
        return onAction('close-modal');
      },
      children: jsx(CloseIcon, {
        css: style.closeIcon
      })
    }), renderContent(pack)]
  });
};

export { Modal as default };